import { PATHS } from 'src/common/constants';
import {
  useStrataManagerSuitesData,
  UseStrataManagerSuitesDataReturn,
} from 'src/pages/StrataManagerSuites/CustomHooks/useStrataManagerSuitesData';
import { IStrataManagerPropertyGroup } from 'src/pages/StrataManagerSuites/types';

export interface UseStrataManagerSuitesOrchestratorReturn {
  propertyGroups: IStrataManagerPropertyGroup[];
  isLoading: boolean;
  error: string | null;
  unitDetailPath: (propertyId: string, unitId: string) => string;
}

export const useStrataManagerSuitesOrchestrator =
  (): UseStrataManagerSuitesOrchestratorReturn => {
    const data: UseStrataManagerSuitesDataReturn = useStrataManagerSuitesData();

    // BOS encodes the suite route id as a `&`-joined composite (propertyId&suiteId).
    const unitDetailPath = (propertyId: string, unitId: string): string =>
      PATHS.SUITES_VIEW.replace(':id', `${propertyId}&${unitId}`);

    return {
      propertyGroups: data.propertyGroups,
      isLoading: data.isLoading,
      error: data.error,
      unitDetailPath,
    };
  };
